<!--Desktop Back Button-->
<div class="container d-back-button d-none d-lg-block">
  <button class="back-btn d-flex align-items-center justify-content-center" (click)="goBack()" aria-label="Back">
    <span class="material-icons text-white">arrow_back_ios</span>
  </button>
</div>

<div class="position-relative">
  <!--Mobile Back Button - overlaid on image-->
  <button
    class="back-btn back-btn--overlay d-flex d-lg-none align-items-center justify-content-center position-absolute"
    (click)="goBack()"
    aria-label="Back"
  >
    <span class="material-icons text-white">arrow_back_ios</span>
  </button>
  <fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
</div>
